import { GivelifyLabel, GivelifyButton } from '@givelify/ui';
import { styled } from '@mui/material/styles';

export const Header = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 32,
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
        marginTop: 16,
        marginBottom: 16,
    },
}));

export const StyledLabel = styled(GivelifyLabel)({
    marginRight: 16,
});

export const StyledButton = styled(GivelifyButton)({
    marginLeft: 'auto',
    minWidth: 200,
});

export const Wrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
});
